import type { FC, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

const ProgressLayout: FC<Props> = (props) => {
  const { children } = props;

  return <div className="col-lg-12 col-md-12">{children}</div>;
};

export default ProgressLayout;
